<template>
  <!-- 알림 팝업 -->
  <div class="pop-alert" :class="`pop-${name}`">
      <div class="container">
          <div class="pop-header clearfix">
              <div class="f-left">{{title}}</div>
              <div class="f-right">
                  <button type="button" class="pop-close" @click="onClose"><span class="blind">팝업닫기</span></button>
              </div>
          </div>
          <div class="pop-content">
              <p>
                <span v-for="(msg, index) in msgBlocks" :key="index">
                  <br v-if="index > 0">{{msg}}
                </span>
              </p>
              <p class="pop-info" v-if="subMsgBlocks.length > 0">
                <span v-for="(msg, index) in subMsgBlocks" :key="`sub_${index}`">
                  <br v-if="index > 0">{{msg}}
                </span>
              </p>
              <button type="button" class="pop-close" @click="onConfirmEvent();">{{confirmText}}</button>
          </div>
      </div>
  </div>
  <!--// 알림 팝업 -->
</template>
<script>

export default {
  props: ['postMessage'],
  data(){
    return {
      title: "알림",
      msgBlocks:[],
      subMsgBlocks:[],
      confirm:null,
      confirmText:"확인",
      name: "common-alert"
    }
  },
  created() {
    this.msgBlocks = this.getMsgBlocks(this.postMessage);
  },
  methods:{
    onConfirmEvent:function(e){
        this.closePopAlert()
        this.$emit('onConfirmEvent',this.confirm);     
        if(this.confirm) 
          this.confirm();
        this.initialize();
    },
    onClose() {
      this.closePopAlert();
      this.initialize();
    },
    initialize() {
      this.title = "알림";
      this.msgBlocks = [];
      this.subMsgBlocks = [];
      this.confirm = null;
      this.confirmText = "확인";
    },

    show(title, msg, confirm, confirmText){
      // console.log(comp, msg)
      // this.postMessage = msg;
      if (title !== undefined) this.title = title;
      this.msgBlocks = this.getMsgBlocks(msg);
      this.subMsgBlocks = [];
      if(confirm)this.confirm = confirm
      if(confirmText)this.confirmText = confirmText;

      // if (this.name.length === 0) {
      //   this.name = comp.$options._componentTag.toLowerCase();
      // }

      this.openPopAlert(this.name);
    },
    // show(msg, subMsg, confirm){
    //   // console.log(comp, msg)
    //   // this.postMessage = msg;
    //   this.msgBlocks = this.getMsgBlocks(msg);
    //   this.subMsgBlocks = this.getMsgBlocks(subMsg);
    //   if(confirm)this.confirm = confirm

    //   // if (this.name.length === 0) {
    //   //   this.name = comp.$options._componentTag.toLowerCase();
    //   // }

    //   this.openPopAlert(this.name);
    // },
    // show(comp, msg, confirm){
    //   console.log(comp, msg)
    //   // this.postMessage = msg;
    //   this.msgBlocks = this.getMsgBlocks(msg);
    //   if(confirm)this.confirm = confirm

    //   if (this.name.length === 0) {
    //     this.name = comp.$options._componentTag.toLowerCase();
    //   }

    //   this.openPopAlert(this.name);
    // },
    getMsgBlocks(msg) {
      if (!msg) return [];
      return msg.split("\n");
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/PopCommonAlert.vue